import { GrChipProps, GrIconProps } from "@jnpmedi/grebob";
import { DocumentSignerStatus, DocumentSignStatus } from "@maven-rest/docs/DocumentSign.dto";

export function resolveDocumentSignerStatusChip(status: DocumentSignerStatus): GrChipProps["color"] {
  switch (status) {
    case DocumentSignerStatus.None:
    case DocumentSignerStatus.Wait:
    case DocumentSignerStatus.Delivered:
    case DocumentSignerStatus.DeliveringSkipped:
    case DocumentSignerStatus.Delivering:
      return "grey";
    case DocumentSignerStatus.Opened:
      return "primary";
    case DocumentSignerStatus.Signed:
      return "green";
    case DocumentSignerStatus.DeliveringFailed:
    case DocumentSignerStatus.Declined:
      return "red";
    default:
      return "grey";
  }
}

export function resolveDocumentSignerTitleIcon(status: DocumentSignerStatus): GrIconProps["type"] {
  switch (status) {
    case DocumentSignerStatus.None:
    case DocumentSignerStatus.Wait:
      return "history-toggle";
    case DocumentSignerStatus.Delivering:
    case DocumentSignerStatus.Delivered:
    case DocumentSignerStatus.DeliveringSkipped:
      return "mail-send";
    case DocumentSignerStatus.Declined:
    case DocumentSignerStatus.DeliveringFailed:
      return "reject";
    case DocumentSignerStatus.Opened:
      return "progress";
    case DocumentSignerStatus.Signed:
      return "check-circle";
    default:
      return "x-mark";
  }
}

export function resolveDocumentSignerTitleIconColor(status: DocumentSignerStatus): GrIconProps["color"] {
  switch (status) {
    case DocumentSignerStatus.Declined:
    case DocumentSignerStatus.DeliveringFailed:
      return "red050";
    case DocumentSignerStatus.Opened:
      return "maven-blue-dark";
    case DocumentSignerStatus.Signed:
      return "positive-primary";
    case DocumentSignerStatus.None:
    case DocumentSignerStatus.Wait:
    case DocumentSignerStatus.Delivering:
    case DocumentSignerStatus.Delivered:
    case DocumentSignerStatus.DeliveringSkipped:
    default:
      return "grey050";
  }
}

export function resolveDocumentSignStatusChipColor(status: DocumentSignStatus): GrChipProps["color"] {
  switch (status) {
    case DocumentSignStatus.Signing:
      return "primary";
    case DocumentSignStatus.SignerDeliveringFailed:
      return "orange";
    case DocumentSignStatus.Finalized:
      return "green";
    case DocumentSignStatus.Declined:
      return "red";
    case DocumentSignStatus.Pending:
    case DocumentSignStatus.Creating:
    case DocumentSignStatus.CreatingFailed:
    case DocumentSignStatus.None:
    case DocumentSignStatus.Wait:
    case DocumentSignStatus.Delivering:
    case DocumentSignStatus.DeliveringFailed:
    case DocumentSignStatus.Delivered:
    case DocumentSignStatus.Signed:
    case DocumentSignStatus.Finalizing:
    case DocumentSignStatus.FinalizingFailed:
    case DocumentSignStatus.Decline:
    case DocumentSignStatus.Declining:
    case DocumentSignStatus.DecliningFailed:
    case DocumentSignStatus.Expiring:
    case DocumentSignStatus.ExpiringFailed:
    case DocumentSignStatus.Expired:
    case DocumentSignStatus.Cancel:
    case DocumentSignStatus.Canceling:
    case DocumentSignStatus.CancelingFailed:
    case DocumentSignStatus.Canceled:
    default:
      return "grey";
  }
}
